import { create } from 'zustand';
import { IlogisticsServicesTrello, ITrello } from '../types/services';
interface ILsTrelloState {
  initialLogisticServices?: IlogisticsServicesTrello;
  logisticServices?: IlogisticsServicesTrello;
  updatedCounter: {
    [key: string]: number;
  };
  dragEndData?: ITrello;
  setDragEndData: (dragEndData?: ITrello) => void;
  setUpdatedCounter: (updatedCounter?: { [key: string]: number }) => void;
  setInitialLogisticServices: (initialLogisticServices?: IlogisticsServicesTrello) => void;
  setLogisticServices: (logisticServices?: IlogisticsServicesTrello) => void;
}
const useLsTrelloState = create<ILsTrelloState>(set => ({
  logisticServices: undefined,
  dragEndData: undefined,
  initialLogisticServices: undefined,
  updatedCounter: {
    cancelado: 0,
    confirmado: 0,
    en_proceso: 0,
    atrasado: 0,
    entregado: 0,
    por_confirmar: 0,
    activo: 0
  },
  setDragEndData: (dragEndData?: ITrello) => set({ dragEndData }),
  setUpdatedCounter: (updatedCounter?: { [key: string]: number }) => set({ updatedCounter }),
  setLogisticServices: (logisticServices?: IlogisticsServicesTrello) => set({ logisticServices }),
  setInitialLogisticServices: (initialLogisticServices?: IlogisticsServicesTrello) => set({ initialLogisticServices })
}));
export default useLsTrelloState;